'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (id, name, loadTarget, targetPath, payload, idTargetSelector, modal, isMultiple) {

    var payloadString = payload ? 'data-payload="' + encodeURIComponent(JSON.stringify(payload)) + '"' : '';
    var modalString = payload ? 'data-modal="' + modal + '"' : '';
    var idString = idTargetSelector ? 'data-target-id="' + idTargetSelector + '"' : '';

    var result = targetPath ? '<a \n            href="' + targetPath + '" \n            data-toggle="load"\n            data-target="' + loadTarget + '" \n            data-id="' + id + '"\n            data-multiple="' + (isMultiple === true ? "true" : "false") + '"\n            ' + payloadString + '\n            ' + modalString + '\n            ' + idString + '\n           >' + name + '</a>' : '<span>' + name + '</span>';

    return result;
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/loadContentLink.js
// module id = 254
// module chunks = 0